import HolrsListModal from './HolrsListModal';

export default HolrsListModal;
